import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fixed inset-0 overflow-y-auto",
  style: {"z-index":"9998"}
}
const _hoisted_2 = { class: "flex items-center justify-center pt-4 px-4 pb-20 text-center sm:p-0" }
const _hoisted_3 = { class: "fixed inset-0 transition-opacity" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-gray-500 opacity-75" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "hidden sm:inline-block sm:align-middle sm:h-screen" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("​ ")
const _hoisted_8 = {
  class: "inline-block overflow-y-auto align-bottom bg-white rounded-md max-h-screen px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "modal-headline"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalCloseButton = _resolveComponent("ModalCloseButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        "enter-active-class": "ease-out duration-300",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "ease-in duration-200",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0",
        onAfterLeave: _cache[0] || (_cache[0] = () => _ctx.$emit('onclose'))
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_3, _hoisted_5, 512), [
            [_vShow, _ctx.isModal]
          ])
        ]),
        _: 1
      }),
      _hoisted_6,
      _hoisted_7,
      _createVNode(_Transition, {
        "enter-active-class": "ease-out duration-300",
        "enter-from-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
        "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-active-class": "ease-in duration-200",
        "leave-from-class": "opacity-100 translate-y-0 sm:scale-100",
        "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_8, [
            _createVNode(_component_ModalCloseButton, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isModal = false))
            }),
            _renderSlot(_ctx.$slots, "default")
          ], 512), [
            [_vShow, _ctx.isModal]
          ])
        ]),
        _: 3
      })
    ])
  ]))
}